import register from '@kpsys/angularjs-register';
import KpDocumentsCarouselComponent from './kp-documents-carousel.component';

export default register('portaro.features.record.kp-documents-carousel')
    .component(KpDocumentsCarouselComponent.componentName, KpDocumentsCarouselComponent)
    .name();
